import { Button } from "components/DesignSystem/Button/Button";
import { LogoutIcon } from "components/icons/LogoutIcon";
import { ProfileHelpIcon } from "components/icons/ProfileHelpIcon";
import Logo from "components/inkleLogo";
import { useModal } from "hooks/useModal";
import { useWindowSize } from "hooks/useWindowSize";
import authContext from "jwt_context&axios/authContext";
import { useContext } from "react";
import Slider from "components/DesignSystem/Slider/Slider";
import { Help } from "components/help/help";

export const AuthHeader = () => {
  const { logoutUser, authtoken } = useContext(authContext);
  const helpModal = useModal();
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const { width, isMobile } = useWindowSize();

  const showLogout = authtoken?.uuid || currentUser?.uuid;

  return (
    <div className="t-flex t-justify-between t-items-center">
      <Logo className="!t-mb-0" />
      <div className="t-flex t-gap-6 t-items-center">
        <Button onClick={helpModal.open} customType="ghost">
          <ProfileHelpIcon color="currentColor" />
          <span className="helpText t-ml-1 !t-text-body-sm !t-font-medium">
            Help
          </span>
        </Button>
        {showLogout && (
          <Button customType="ghost" onClick={logoutUser}>
            <LogoutIcon />
            <span className="t-ml-1 t-text-body-sm t-font-medium">Logout</span>
          </Button>
        )}
      </div>
      {helpModal.isOpen && (
        <Slider.Root open={helpModal.isOpen} onOpenChange={helpModal.close}>
          <Slider.Content
            open={helpModal.isOpen}
            width={isMobile ? "100vw" : undefined}
          >
            <Help close={helpModal.close} />
          </Slider.Content>
        </Slider.Root>
      )}
    </div>
  );
};
